import { render, staticRenderFns } from "./opentrenderslist.vue?vue&type=template&id=c9313e3c&scoped=true"
import script from "./opentrenderslist.vue?vue&type=script&lang=js"
export * from "./opentrenderslist.vue?vue&type=script&lang=js"
import style0 from "./opentrenderslist.vue?vue&type=style&index=0&id=c9313e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9313e3c",
  null
  
)

export default component.exports